<mat-card appearance="outlined">
  <mat-card-header>
    <mat-icon mat-card-avatar class="email"></mat-icon>
    <mat-card-title class="card-title">{{ 'INBOX.SETTINGS.EMAIL_SETTINGS.TITLE' | translate }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="sender-info-title">
      <strong>{{ 'INBOX.SETTINGS.EMAIL_SETTINGS.DESCRIPTION' | translate }}</strong>
      <mat-icon [glxyTooltip]="'INBOX.SETTINGS.EMAIL_SETTINGS.SENDER_PREVIEW_INFO_DESCRIPTION' | translate">
        info_outline
      </mat-icon>
    </div>
    <div class="sender-info-content">
      <mat-icon>person</mat-icon>
      <div class="sender-email-preview">
        @if (forwardingEmailTitle$ | async; as forwardingEmailTitle) {
          <div class="sender-email-title">
            {{ forwardingEmailTitle.translationKey | translate: forwardingEmailTitle }}
          </div>
        }
        <div class="sender-email-address"><{{ this.senderInfoEmailAddress() }}></div>
      </div>
    </div>
    <div class="actions">
      <button mat-flat-button color="primary" routerLink="../email-configuration">
        {{ 'INBOX.SETTINGS.EMAIL_SETTINGS.CONFIGURE_EMAIL' | translate }}
      </button>
    </div>
  </mat-card-content>
</mat-card>
